import { APIClient, ApiQueryParams, DefaultQueryParams } from '@frontend/api-utils';

import {
    CreateNotificationTemplate,
    NotificationTemplate,
    NotificationTemplateListResponse,
    SearchNotificationTemplateQueryParams,
    UpdateNotificationTemplate
} from '../notification-template';

const endpoint = '/notification-service/api/v1';
export class NotificationTemplateClient extends APIClient {
    public static async fetchNotificationTemplates(queryParams?: ApiQueryParams<DefaultQueryParams>): Promise<NotificationTemplateListResponse> {
        return await this.apiPaginated<NotificationTemplateListResponse, DefaultQueryParams>(`${endpoint}/templates`, queryParams);
    }

    public static async searchNotificationTemplate(
        queryParams?: ApiQueryParams<DefaultQueryParams | SearchNotificationTemplateQueryParams>
    ): Promise<NotificationTemplateListResponse> {
        return await this.apiPaginated<NotificationTemplateListResponse, DefaultQueryParams | SearchNotificationTemplateQueryParams>(
            `${endpoint}/templates-search`,
            queryParams
        );
    }

    public static async fetchAccountNotificationTemplates(
        accountId: string,
        queryParams?: ApiQueryParams<DefaultQueryParams>
    ): Promise<NotificationTemplateListResponse> {
        return await this.apiPaginated<NotificationTemplateListResponse, DefaultQueryParams>(`${endpoint}/accounts/${accountId}/templates`, queryParams);
    }

    public static async postAccountNotificationTemplate(accountId: string, notificationTemplate: CreateNotificationTemplate): Promise<NotificationTemplate> {
        const response = await this.post(`${endpoint}/accounts/${accountId}/templates`, notificationTemplate);
        return await this.handleResponse<NotificationTemplate>(response);
    }

    public static async fetchAccountNotificationTemplate(accountId: string, notificationTemplateId: string): Promise<NotificationTemplate> {
        const response = await this.fetch(`${endpoint}/accounts/${accountId}/templates/${notificationTemplateId}`);
        return await this.handleResponse<NotificationTemplate>(response);
    }

    public static async patchAccountNotificationTemplate(
        notificationTemplate: UpdateNotificationTemplate,
        accountId: string,
        notificationTemplateId: string
    ): Promise<NotificationTemplate> {
        const response = await this.patch(`${endpoint}/accounts/${accountId}/templates/${notificationTemplateId}`, notificationTemplate);
        return await this.handleResponse<NotificationTemplate>(response);
    }

    public static async deleteAccountNotificationTemplate(accountId: string, notificationTemplateId: string): Promise<void> {
        const response = await this.delete(`${endpoint}/accounts/${accountId}/templates/${notificationTemplateId}`);
        return await this.handleVoidResponse(response);
    }
}
